"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HashMap;

var _ArrayList = _interopRequireDefault(require("./ArrayList"));

var _Map = _interopRequireDefault(require("./Map"));

var _HashSet = _interopRequireDefault(require("./HashSet"));

var _Map2 = _interopRequireDefault(require("../../Map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapImpl = typeof Map === 'undefined' || !Map.prototype.values ? _Map2.default : Map;
/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/HashMap.html
 *
 * @extends {javascript.util.Map}
 * @constructor
 * @private
 */

function HashMap() {
  /**
   * @type {Object}
   * @private
  */
  this.map_ = new MapImpl();
}

HashMap.prototype = new _Map.default();
/**
 * @override
 */

HashMap.prototype.get = function (key) {
  return this.map_.get(key) || null;
};
/**
 * @override
 */


HashMap.prototype.put = function (key, value) {
  this.map_.set(key, value);
  return value;
};
/**
 * @override
 */


HashMap.prototype.values = function () {
  var arrayList = new _ArrayList.default();
  var it = this.map_.values();
  var o = it.next();

  while (!o.done) {
    arrayList.add(o.value);
    o = it.next();
  }

  return arrayList;
};
/**
 * @override
 */


HashMap.prototype.entrySet = function () {
  var hashSet = new _HashSet.default();
  this.map_.entries().forEach(function (entry) {
    return hashSet.add(entry);
  });
  return hashSet;
};
/**
 * @override
 */


HashMap.prototype.size = function () {
  return this.map_.size();
};